import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { appCheck, db } from "../../../../firebase/firebase";
import "./SignatureBook.css";
import { getToken } from "firebase/app-check";

interface GuestbookEntry {
  id: string;
  name: string;
  message: string;
  filePath: string;
  token: string;
  createdAt?: string;
  signatureUrl?: string;
}

export const SignatureBook = () => {
  const [entries, setEntries] = useState<GuestbookEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        const { token: appCheckToken } = await getToken(appCheck, false);

        const res = await fetch(
          "https://us-central1-wedding-bca0e.cloudfunctions.net/listGuestEntries",
          {
            headers: {
              "X-Firebase-AppCheck": appCheckToken,
            },
          }
        );
        if (!res.ok) throw new Error(await res.text());
        const data: GuestbookEntry[] = await res.json();

        const withUrl = await Promise.all(
          data.map(async (entry) => {
            const { token: acToken2 } = await getToken(appCheck, false);
            const urlRes = await fetch(
              `https://us-central1-wedding-bca0e.cloudfunctions.net/getSignedImageUrl` +
                `?token=${encodeURIComponent(entry.token)}` +
                `&filePath=${encodeURIComponent(entry.filePath)}`,
              { headers: { "X-Firebase-AppCheck": acToken2 } }
            );
            if (urlRes.ok) {
              const { url } = await urlRes.json();
              entry.signatureUrl = url;
            }
            return entry;
          })
        );

        setEntries(withUrl);
      } catch (err) {
        console.error("Error fetching entries:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEntries();
  }, []);

  if (loading) return <div>Cargando firmas...</div>;
  if (!entries.length) return <div>No hay firmas todavía.</div>;

  return (
    <div className="signature-book-list">
      {entries.map((e) => (
        <div className="signature-entry" key={e.id}>
          <div className="signature-entry-label">
            <strong>Nombre:</strong> {e.name || "Anónimo"}
            {e.createdAt && (
              <span style={{ fontSize: 12, color: "#888", marginLeft: 8 }}>
                {new Date(e.createdAt).toLocaleString()}
              </span>
            )}
          </div>
          <div className="signature-entry-label">
            <strong>Mensaje:</strong> <em>{e.message}</em>
          </div>
          {e.signatureUrl && (
            <div className="signature-entry-label signature-entry-image">
              <strong>Dibujo:</strong>
              <br />
              <img
                src={e.signatureUrl}
                alt={`Firma de ${e.name}`}
                style={{
                  maxWidth: 300,
                  maxHeight: 120,
                  border: "1px solid #ccc",
                  background: "#fff",
                  marginTop: 4,
                  borderRadius: 8,
                }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
